<template>
  <div id="announcement">
    <v-row
      ><v-col cols="12"
        ><h2>Announcement</h2>
        <v-card class="mx-auto">
          <v-card-title>
            <v-spacer></v-spacer>
            <v-col cols="3"
              ><v-text-field
                outlined
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
              ></v-text-field
            ></v-col>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="dataProjectAnnounce"
              :search="search"
            >
              <template v-slot:item="{ item }">
                <tr @click="rowClicked(item)" class="row-project">
                  <td>{{ item.projectCode }}</td>
                  <td>{{ item.subject }}</td>
                  <td>{{ moment(item.startDate).format("YYYY-MM-DD") }}</td>
                  <td>{{ moment(item.endDate).format("YYYY-MM-DD") }}</td>
                  <td>
                    <v-chip
                      small
                      dark
                      :color="
                        setChipStatusColor(
                          item.projectStatus,
                          item.vendorProjectStatus
                        )
                      "
                    >
                      {{ item.vendorProjectStatus }}
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      class="ma-2"
                      :color="
                        selectedRows.indexOf(item.projectId) > -1
                          ? 'secondary'
                          : 'primary'
                      "
                      icon
                      :to="setUrlRedirect(item.projectId)"
                    >
                      <v-icon> mdi-eye </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card></v-col
      ></v-row
    >
  </div>
</template>

<script>
import { _projectservice } from "../services/projectservice";

export default {
  name: "announcement",
  data: () => ({
    search: "",
    dataProjectAnnounce: [],
    selectedBiddingProject: {},
    headers: [
      {
        text: "Project Code",
        align: "start",
        sortable: false,
        value: "projectCode",
      },
      { text: "Subject", value: "subject" },
      { text: "Bidding Start Date", value: "startDate" },
      { text: "Bidding End Date", value: "endDate" },
      { text: "Project Status", value: "projectStatus" },
      { text: "Action", value: "action" },
    ],
    selectedRows: [],
  }),

  created() {
    this.getBiddingProjectAnnouncement();
  },
  mounted() {
    this.selectedRows = this.$store.state.logSelectionAnnouncement;
  },
  computed: {
    logSelectionAnnouncement() {
      return this.$store.state.logSelectionAnnouncement;
    },
  },
  watch: {
    logSelectionAnnouncement(v) {
      this.selectedRows = v;
    },
  },
  methods: {
    async rowClicked(row) {
      await this.toggleSelection(row.projectId);
      if (row.projectId) {
        this.dataProjectAnnounce.map((item, index) => {
          item.selected = item === row;

          this.$set(this.dataProjectAnnounce, index, item);
        });
        this.$router
          .push(`/${this.$i18n.locale}/bidding/main/${row.projectId}`)
          .catch(() => {});
      }
    },
    toggleSelection(keyID) {
      if (this.selectedRows.includes(keyID)) {
        this.selectedRows = this.selectedRows.filter(
          (selectedKeyID) => selectedKeyID !== keyID
        );
      } else {
        this.$store.dispatch("AddLogSelectionAnnouncement", keyID);
      }
    },
    async getBiddingProjectAnnouncement() {
      this.$loading(true);
      const payload = {
        subject: "",
        projectDescription: "",
        startDate: null,
        endDate: null,
      };

      this.dataProjectAnnounce =
        await _projectservice.GetBiddingProjectAnnouncement(payload);

      this.$loading(false);

      // console.log("Bidding Project Announce", this.dataProjectAnnounce);
    },
    setChipStatusColor(status, vendor) {
      let color = "";
      if (vendor == "Open") color = "#2980B9";
      if (vendor == "On Process") color = "warning";
      if (vendor == "Re-Open") color = "#8E44AD";
      if (vendor == "Award") color = "#3498DB";
      if (vendor == "Complete") color = "#2ECC71";

      return color;
    },
    setUrlRedirect(projectId) {
      return `/${this.$i18n.locale}/bidding/main/${projectId}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.row-project {
  cursor: pointer;
}
</style>
